import axios from "axios";
import { API_BASE_URL } from "../config/apiConfig";

const token = () => localStorage.getItem("authToken");
const headers = () => ({ Authorization: `${token()}` });

export const descargarBackupExcel = async (tipo) => {
  const response = await axios.get(
    `${API_BASE_URL}/gestion-masiva/backup/${tipo}`,
    {
      headers: headers(),
      responseType: "blob",
    }
  );
  return response;
};

// Descargar plantilla vacía
export const descargarPlantillaExcel = async (tipo) => {
  const response = await axios.get(
    `${API_BASE_URL}/gestion-masiva/plantilla/${tipo}`,
    {
      headers: headers(),
      responseType: "blob",
    }
  );
  return response;
};

// Crear estudiantes masivamente
export const crearEstudiantesMasivo = async (file) => {
  const formData = new FormData();
  formData.append("file", file);

  const response = await axios.post(
    `${API_BASE_URL}/gestion-masiva/crear-estudiantes`, // 🔹 Usar API_BASE_URL
    formData,
    {
      headers: {
        ...headers(), // 🔹 Incluir token de autenticación
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response;
};

// Crear profesores masivamente
export const crearProfesoresMasivo = async (file) => {
  const formData = new FormData();
  formData.append("file", file);

  const response = await axios.post(
    `${API_BASE_URL}/gestion-masiva/crear-profesores`, // 🔹 Usar API_BASE_URL
    formData,
    {
      headers: {
        ...headers(), // 🔹 Incluir token de autenticación
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response;
};

export const eliminarEstudiantesMasivo = async (data) => {
  const response = await axios.post(
    `${API_BASE_URL}/gestion-masiva/eliminar-estudiantes`,
    data,
    { headers: headers() }
  );
  return response.data;
};

export const eliminarProfesoresMasivo = async (data) => {
  const response = await axios.post(
    `${API_BASE_URL}/gestion-masiva/eliminar-profesores`,
    data,
    { headers: headers() }
  );
  return response.data;
};